import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { ReportFilterModel } from './report-filter.model';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class VehicleOccupancyService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();

  constructor(private authService: AuthService, private http: Http) { }

  public GenerateVehicleOccupancyReport(model: ReportFilterModel): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_VEHICLE_OCCUPANCY_REPORT;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    return this.http.get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVehicleOccupancyReportPDF(model: ReportFilterModel): any {
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    let getInstanceUrl = WeGoConfig.API_EXPORT_VEHICLE_OCCUPANCY_REPORT_PDF + "?" + queryStringReportFilterModel;
    let headers = this.authService.GetHeader('application/pdf');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getInstanceUrl, options);
  }

  public ExportVehicleOccupancyReportExcel(model: ReportFilterModel): any {
    let getUrl = WeGoConfig.API_EXPORT_VEHICLE_OCCUPANCY_REPORT_EXCEL;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    let headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getUrl, options);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/vehicle-occupancy.service.ts